export class ui_log_entry {
    public utc!: string;           // ISO string
    public level!: string;         // Information | Warning | Error | Critical | ...
    public category!: string;
    public message!: string;

    public exception: string | null = null;

    // Correlación
    public trace_id: string | null = null;
    public span_id: string | null = null;

    // Enriquecimiento
    public props: any = null;

    // Campos rápidos
    public http_method: string | null = null;
    public http_path: string | null = null;
    public ip: string | null = null;
    public user: string | null = null;

    // Opcionales si los guardas en backend
    public event_id: number | null = null;
    public event_name: string | null = null;

    constructor(src?: any) {
        if (src) {
            Object.assign(this, src);
        }
    }
}
